import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import Dotdotdot from 'react-dotdotdot';
import classNames from 'classnames';
import { isMobileBreakpoint } from 'helpers/BreakpointHelper';
import { isInternalLink } from 'helpers/ContentHelper';

const TileTitle = ({
  breakpoint,
  isDisabled,
  isRedirect,
  isSeriesDetailAvailable,
  isUpcoming,
  link,
  onClick,
  onTileMouseDown,
  Style,
  target,
  title,
  titleLines,
}) => {
  if (!title || title.length === 0) return null;
  let titleLink = link;
  const titleClasses = [Style.title];
  const shouldUseNativeClamp = isMobileBreakpoint(breakpoint);
  const titleClass = isDisabled ? classNames([Style.title, Style.disabled]) : Style.title;
  const text = titleLines ? (
    <div className={Style.ellipsisTitle} data-test="dotdotdot-container">
      <Dotdotdot useNativeClamp={shouldUseNativeClamp} clamp={titleLines}>
        {title}
      </Dotdotdot>
    </div>
  ) : (
    title
  );
  if (!link || isDisabled) return <div className={titleClass}>{text}</div>;
  if (isRedirect) {
    titleLink = null;
    titleClasses.push(Style.redirectLink);
  }

  if (isUpcoming && isSeriesDetailAvailable === false) {
    titleLink = null;
  } else {
    titleClasses.push(Style.titleV2);
  }

  if (isInternalLink(titleLink)) {
    return (
      <Link
        onClick={onClick}
        onMouseDown={onTileMouseDown}
        to={titleLink}
        target={target}
        className={classNames(titleClasses)}
      >
        {text}
      </Link>
    );
  }
  return (
    <a
      onClick={onClick}
      onMouseDown={onTileMouseDown}
      href={titleLink}
      className={classNames(titleClasses)}
    >
      {text}
    </a>
  );
};

export default TileTitle;

TileTitle.propTypes = {
  breakpoint: PropTypes.string,
  isDisabled: PropTypes.bool,
  isRedirect: PropTypes.bool,
  isSeriesDetailAvailable: PropTypes.bool,
  isUpcoming: PropTypes.bool,
  link: PropTypes.string,
  onClick: PropTypes.func,
  onTileMouseDown: PropTypes.func,
  Style: PropTypes.shape({}).isRequired,
  target: PropTypes.string,
  title: PropTypes.node,
  titleLines: PropTypes.number,
};
